export function dataInRequest(params = {}) {
  return {
    type: '@linhaAbastecimento/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@linhaAbastecimento/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@linhaAbastecimento/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@linhaAbastecimento/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@linhaAbastecimento/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@linhaAbastecimento/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@linhaAbastecimento/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@linhaAbastecimento/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@linhaAbastecimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@linhaAbastecimento/RECORD_FILTERING',
    payload: { params },
  };
}
